export const currencyMask = (text: string) => {
  if (text) {
    let value = text;
    value = value.replace(/\D/g, '');
    value = value.replace(/(\d)(\d{2})$/, '$1,$2');
    value = value.replace(/(?=(\d{3})+(\D))\B/g, '.');
    return value;
  }
  return '';
};

export const doubleCurrencyMask = (text: string) => {
  if (text) {
    let value = text;
    value = value.replace(/\D/g, '');
    value = value.replace(/(\d)(\d{2})$/, '$1.$2');
    return Number(value);
  }
  return NaN;
};
